import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Select,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useRecoilState, useSetRecoilState } from "recoil";
import { FiArrowLeft, FiPlus, FiXCircle } from "react-icons/fi";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";
import { NumericFormat, PatternFormat } from "react-number-format";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import { componentState } from "../../../../atoms/componentState";
import { useEffect, useState } from "react";
import ExtratoApi from "../../../../services/ExtratoAPI";
import PaymentApi from "../../../../services/paymentApi";
import ClientApi from "../../../../services/clientApi";
import {
  dateForList,
  dateForValueInput,
} from "../../../../constants/dataFormat";
import { goToPaymentSolicitationList } from "../../../../routes/coordinator";
import { cnpj as cnpjValidator, cpf as cpfValidator } from "cpf-cnpj-validator";
import { JWTToken } from "../../listaDeVendas/SalesList";
import jwt_decode from "jwt-decode";
import { customColors } from "../../../../atoms/customColors";
import ModalSendACodeToPay from "../../../login/components/modalSendACodeToPay";
import { LoggedUser } from "../../../../atoms/userLogged";
const utils = require("@mrmgomes/boleto-utils");

function AddPayment() {
  const navigate = useNavigate();

  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];
  const [cliente, setCliente] = useState(0);
  const todayMorning = moment()
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss.SSS");
  const todayNight = moment()
    .endOf("day")
    // .add("day", 2)
    .format("YYYY-MM-DDTHH:mm:ss.SSS");
  const [saldoCliente, setSaldoCliente] = useState(0);
  const [nomeCliente, setNomeCliente] = useState("");
  const [loading, setLoading] = useState(false);

  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const id = Number(jwtToken.idCliente);
  const colors = useRecoilState(customColors)[0];

  interface IFormInputs {
    idCliente: any;
    codigoBarras: string;
    nomeCliente: string;
    valorNominal: number;
    valorPagamento: number;
    juros: number;
    descontos: number;
    vencimento: string;
    dataPagamento: string;
    nomeBeneficiario: string;
    cnpjBeneficiario: string;
    observacao: string;
  }
  const initialValues = {
    idCliente: id,
    nomeCliente: "",
    codigoBarras: "",
    valorNominal: 0,
    valorPagamento: 0,
    juros: 0,
    descontos: 0,
    vencimento: "",
    dataPagamento: "",
    nomeBeneficiario: "",
    cnpjBeneficiario: "",
    observacao: "",
  };

  const [pagamento, setPagamento] = useState<IFormInputs>(initialValues);
  const [listaPagamento, setListaPagamento] = useState(Array<IFormInputs>);
  const schema = yup
    .object({
      vencimento: yup
        .string()
        .required("A data de vencimento deve ser preenchida!"),
      // codigoBarras: yup.string().required("Digite o código de barras!"),
      // hora: yup.string().required("A hora do laançamento deve ser preenchida"),
      // valorNominal: yup.number().required("O valorNominal deve ser preenchido")
    })
    .required();
  const {
    register,
    handleSubmit,
    watch,
    setError,
    formState: { errors },
  } = useForm<IFormInputs>({ resolver: yupResolver(schema) });

  async function getSaldo() {
    try {
      const response = await ExtratoApi.getSaldo(
        1,
        100,
        todayMorning,
        todayNight,
        id
      );
      setSaldoCliente(
        response.data[0] &&
          response.data[0].saldoAnterior + response.data[0].saldoPeriodo
      );
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    getSaldo();
  }, []);

  const [code, setCode] = useState("");

  function onSubmit() {
    if (
      pagamento.codigoBarras !== "" &&
      // pagamento.cnpjBeneficiario != "" &&
      pagamento.valorNominal !== 0 &&
      // pagamento.nomeBeneficiario != "" &&
      pagamento.vencimento !== "" &&
      pagamento.dataPagamento !== ""
    ) {
      if (
        saldoCliente >=
        pagamento.valorNominal + sumPaymentList() - pagamento.descontos
      ) {
        const objeto = {
          idCliente: id,
          nomeCliente: nomeCliente,
          codigoBarras: pagamento.codigoBarras,
          nomeBeneficiario: pagamento.nomeBeneficiario,
          cnpjBeneficiario: unMask(pagamento.cnpjBeneficiario),
          dataPagamento: pagamento.dataPagamento,
          vencimento: pagamento.vencimento,
          valorNominal: pagamento.valorNominal,
          valorPagamento: pagamento.valorNominal,
          descontos: pagamento.descontos,
          juros: pagamento.juros,
          observacao: pagamento.observacao,
        };
        setListaPagamento([...listaPagamento, objeto]);
        setPagamento(initialValues);
        setCliente(0);
      } else {
        toast.error("O saldo é insuficiente para a operação!");
      }
    } else {
      toast.error("Preencha os campos para registrar a solicitação!");
    }
  }

  async function postPagamentos(codeResponse: string) {
    try {
      setLoading(true);
      const response = await PaymentApi.postPaymentSolicitation(
        listaPagamento,
        codeResponse
      );
      toast.success("Solicitações de pagamento registradas com sucesso!");
      toast.success("Seu boleto será processado em breve!");
      setRefreshGlobal(refresh + 1);
      setListaPagamento([]);
      goToPaymentSolicitationList(navigate);
      setLoading(false);
    } catch (error) {
      toast.error("Não foi possível cadastrar as solicitações");
      setLoading(false);
      console.log("error: " + error);
    }
  }

  function onChangeDescontoFilter(e: any) {
    setPagamento({
      ...pagamento,
      descontos: Number(e.slice(3).replace(",", ".")),
    });
  }
  function OnChangeValueInput(e: any) {
    setPagamento({
      ...pagamento,
      valorNominal: Number(e.slice(3).replace(",", ".")),
    });
  }
  function OnChangeJurosInput(e: any) {
    setPagamento({ ...pagamento, juros: Number(e.slice(3).replace(",", ".")) });
  }

  function sumPaymentList() {
    const valores = listaPagamento
      .map((item: any) => item.valorNominal)
      .reduce((a, b) => a + b, 0);
    return valores;
  }

  let soma = sumPaymentList().toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

  function validaData(item: any) {
    if (moment(item) < moment().startOf("day")) {
      toast.error("A data não pode ser anterior ao dia de hoje!");
    }
  }

  const unMask = (value: any) => {
    return value.replace(/[^0-9]/g, "");
  };

  function validateCNPJ(cnpj: any) {
    const temp = cnpj.match(/\d/g).join("");
    if (temp.length > 11) {
      if (!cnpjValidator.isValid(temp)) {
        setError("cnpjBeneficiario", {
          type: "onBlur",
          message: "Este CNPJ não é válido!",
        });
      } else {
        setError("cnpjBeneficiario", { type: "onBlur", message: "" });
      }
    } else {
      if (!cpfValidator.isValid(temp)) {
        setError("cnpjBeneficiario", {
          type: "onBlur",
          message: "Este CPF não é válido!",
        });
      } else {
        setError("cnpjBeneficiario", { type: "onBlur", message: "" });
      }
    }
  }

  async function getClientPerId() {
    try {
      const response = await ClientApi.getClientPerId(id);
      setNomeCliente(
        response.isCnpj === true
          ? response.razaoSocial
          : `${response.nome} ${response.sobrenome}`
      );
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    getClientPerId();
  }, []);

  function getInformationByBarCode(item: any) {
    const _item = item.replace(/\s/g, "");
    // const last = _item.slice(_item.length, -1);
    // console.log("código de barras", item);
    if (pagamento.codigoBarras.startsWith("8")) {
      //inserir validações para boleto de arrecadação
    } else if (!pagamento.codigoBarras.startsWith("8") && _item !== "") {
      const valor_inteiro_boleto = _item.slice(40, 48);
      const valor_double_boleto = _item.slice(48, 50);
      const valor_boleto = valor_inteiro_boleto + "." + valor_double_boleto;
      const data_boleto = _item.slice(36, 40);
      const data_vencimento = moment
        .utc("1997-10-07")
        .add(+data_boleto + 1, "days")
        .local()
        .format(dateForValueInput);
      if (moment(data_vencimento) < moment().startOf("day")) {
        toast.error("O boleto digitado já está vencido! ");
        setError("codigoBarras", {
          type: "onBlur",
          message:
            "Este boleto já está vencido! Para prosseguir com o pagamento digite corretamente os juros.",
        });
        setPagamento({
          ...pagamento,
          vencimento: moment(data_vencimento).format("YYYY-MM-DDTHH:mm:ss.SSS"),
          valorNominal: Number(valor_boleto),
        });
      } else {
        setError("codigoBarras", { type: "onBlur", message: "" });
        setPagamento({
          ...pagamento,
          vencimento: moment(data_vencimento).format("YYYY-MM-DDTHH:mm:ss.SSS"),
          valorNominal: Number(valor_boleto),
        });
      }
    } else if (_item === "") {
      setError("codigoBarras", {
        type: "onBlur",
        message: "Digite o código do boleto.",
      });
    }
    // console.log("data do boleto", data_boleto);
    // console.log("data de vencimento", data_vencimento);
  }

  const MASK_ARRECADACAO =
    "############ ############ ############ ############";
  const MASK_COBRANCA =
    "#####.##### #####.###### #####.###### # ##############";

  const validarSeFinalDeSemana = (e: any) => {
    const validarData = new Date(e.target.value);
    const NaoFinalDeSemana =
      validarData.getDay() !== 5 && validarData.getDay() !== 6;
    const e_valido = validarMesmoDiaEAntesDasDezoitoHoras(e.target.value);
    if (e_valido) {
      if (NaoFinalDeSemana) {
        setPagamento({
          ...pagamento,
          dataPagamento: moment(e.target.value).format(
            "YYYY-MM-DDTHH:mm:ss.SSS"
          ),
        });
      } else {
        toast.error("A data não pode ser um final de semana!");
      }
    } else {
      toast.error(
        "Não é possível realizar solicitações para o mesmo dia após as 18hs!"
      );
    }
  };

  function validarMesmoDiaEAntesDasDezoitoHoras(data: any) {
    const horaDaSolicitacao = moment().format("HH.mm");
    const diadaSolicitação =
      moment().format("DD-MM-YYYY") === moment(data).format("DD-MM-YYYY");
    if (diadaSolicitação) {
      return Number(horaDaSolicitacao) < 18;
    }
    return true;
  }

  const [isLeitorCodigos, setIsLeitorCódigo] = useState(false);

  const handleChange = () => {
    setIsLeitorCódigo(!isLeitorCodigos);
    setPagamento({
      ...pagamento,
      codigoBarras: "",
    });
  };

  const [openCodeModal, setOpenCodeModal] = useState(false);
  const user = useRecoilState(LoggedUser)[0];

  return (
    <Flex flexDir={"column"} height="fit-content" width="100%">
      <Box
        width={"100%"}
        bgColor={colors.WHITE}
        height={"fit-content"}
        shadow={"md"}
        justifyItems={"center"}
        mt={"0.3%"}
        mx="auto"
        py={2}
        px={3}
      >
        <Flex
          px={5}
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Text fontWeight="bold" fontSize="18px">
            Nova Solicitação de Pagamento de Boletos
          </Text>
          <Button
            leftIcon={<FiArrowLeft />}
            bgColor={colors.GRAY_NEUTRAL}
            style={{ color: "white" }}
            onClick={() => {
              goToPaymentSolicitationList(navigate);
            }}
          >
            Voltar
          </Button>
        </Flex>
      </Box>
      <Flex w={"100%"} h={"84vh"} overflowY={"scroll"} flexDirection={"column"}>
        <Box
          width={"100%"}
          bgColor={colors.WHITE}
          height={"fit-content"}
          shadow={"md"}
          justifyItems={"center"}
          mt={"0.3%"}
          mx="auto"
          py={2}
          px={3}
        >
          <Flex
            justify="flex-start"
            ml={4}
            flexDirection={"column"}
            color={colors.BLUEMONEDD}
          >
            <Text fontSize={"12px"} my={1}>
              Informe os dados a seguir e clique em adicionar.
            </Text>
            <Text fontSize={"12px"} my={1}>
              Ao terminar de adicionar seus pagamentos, clique em finalizar para
              enviar os pagamentos para nós.
            </Text>
            <Text fontSize={"12px"} my={1}>
              Atenção : No campo valor, informe o valor correto a ser pago do
              boleto.
            </Text>
            <Text fontSize={"12px"} my={1}>
              Caso exista juro e/ou desconto, insira o valor separadamente, em
              seu respectivos campo, por não sermos um Banco, o sistema Monedd
              não efetua o cálculo dos mesmos de forma automática.
            </Text>
            <Text fontSize={"12px"} fontWeight={"500"} my={1}>
              * Máximo de 5 boletos a cada envio.
            </Text>
            <Text fontSize={"12px"} fontWeight={"500"} my={1}>
              * Solicitações de pagamentos bancários só são possíveis de 00h até
              ás 18h, de segunda a sexta, exceto feriados.
            </Text>
            <Text fontSize={"12px"} fontWeight={"500"} my={1}>
              * Não é possível realizar solicitações de pagamentos bancários
              após as 18h, finais de semana e feriados.
            </Text>
            <Text fontSize={"12px"} fontWeight={"500"} my={1}>
              * Cliente Monedd tem direito a pagamentos de boletos sem custo e
              sem limite de quantidade.
            </Text>
          </Flex>
        </Box>
        <Box
          width={"100%"}
          bgColor={colors.WHITE}
          height={"fit-content"}
          shadow={"md"}
          mt={"0.3%"}
          mx="auto"
          py={3}
          px={10}
        >
          <Flex width={"100%"} height={"60%"} flexDirection="column" mb={"3%"}>
            <form>
              {/* <FormControl my={2} w={"40%"}>
                <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                  Cliente
                </FormLabel>
                <ClientSelect cliente={cliente} setCliente={setCliente} />
              </FormControl> */}
              <Flex my={2} flexDirection={"column"}>
                <Text fontWeight={"bold"} my={1}>
                  Saldo:{" "}
                  {saldoCliente
                    ? saldoCliente.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    : "R$ 0,00"}
                </Text>
                <Text fontWeight={"bold"} my={1}>
                  Montante a pagar: {soma}
                </Text>
              </Flex>
              <Flex>
                <FormControl>
                  <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                    Linha Digitável
                    <Flex>
                      <FormLabel fontSize={"12px"} mt={2}>
                        <Checkbox
                          mr={2}
                          isChecked={isLeitorCodigos}
                          onChange={handleChange}
                        />
                        Utilizar leitor de códigos de barras
                      </FormLabel>
                    </Flex>
                  </FormLabel>
                  <PatternFormat
                    customInput={Input}
                    format={
                      pagamento.codigoBarras.startsWith("8")
                        ? MASK_ARRECADACAO
                        : MASK_COBRANCA
                    }
                    placeholder={"Código de Barras"}
                    value={pagamento.codigoBarras}
                    {...register("codigoBarras", { required: true })}
                    onChange={(e: any) => {
                      if (isLeitorCodigos) {
                        const linhaDigitavel = utils.codBarras2LinhaDigitavel(
                          e.target.value,
                          false
                        );
                        setPagamento({
                          ...pagamento,
                          codigoBarras: linhaDigitavel,
                        });
                      } else {
                        setPagamento({
                          ...pagamento,
                          codigoBarras: e.target.value,
                        });
                      }
                    }}
                    onBlur={(e: any) => {
                      getInformationByBarCode(e.target.value);
                    }}
                  />
                  <Text color={colors.REDMONEDD}>
                    {errors.codigoBarras?.message}{" "}
                  </Text>
                </FormControl>
              </Flex>
              <Flex flexDir={"row"}>
                <FormControl my={2} mx={2}>
                  <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                    Valor Nominal
                  </FormLabel>
                  <NumericFormat
                    decimalScale={2}
                    prefix="R$ "
                    value={pagamento.valorNominal}
                    decimalSeparator=","
                    customInput={Input}
                    type="text"
                    placeholder="R$ 0,00"
                    onChange={(e: any) => {
                      OnChangeValueInput(e.target.value);
                    }}
                  />
                </FormControl>
                <FormControl my={2} mx={2}>
                  <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                    Juros
                  </FormLabel>
                  <NumericFormat
                    decimalScale={2}
                    prefix="R$ "
                    value={pagamento.juros}
                    decimalSeparator=","
                    customInput={Input}
                    type="text"
                    placeholder="R$ 0,00"
                    onChange={(e: any) => {
                      OnChangeJurosInput(e.target.value);
                    }}
                  />
                </FormControl>
                <FormControl my={2} mx={2}>
                  <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                    Descontos
                  </FormLabel>
                  <NumericFormat
                    decimalScale={2}
                    prefix="R$ "
                    value={pagamento.descontos}
                    decimalSeparator=","
                    customInput={Input}
                    type="text"
                    placeholder="R$ 0,00"
                    onChange={(e: any) => {
                      onChangeDescontoFilter(e.target.value);
                    }}
                  />
                </FormControl>
                <FormControl my={2} mx={2}>
                  <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                    Data de Vencimento
                  </FormLabel>
                  <Input
                    type="date"
                    placeholder="Digite o nome do projeto"
                    value={moment(pagamento.vencimento).format("YYYY-MM-DD")}
                    // min={moment().startOf("day").format(dateForValueInput)}
                    {...register("vencimento", { required: true })}
                    onChange={(e: any) => {
                      setPagamento({
                        ...pagamento,
                        vencimento: moment(e.target.value).format(
                          "YYYY-MM-DDTHH:mm:ss.SSS"
                        ),
                      });
                    }}
                    // onBlur={(e: any) => {
                    //   validaData(e.target.value);
                    // }}
                  />
                  <FormErrorMessage>
                    {errors.vencimento?.message}
                  </FormErrorMessage>
                </FormControl>
                <FormControl my={2} mx={2}>
                  <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                    Data para Pagamento
                  </FormLabel>
                  <Input
                    type="date"
                    placeholder="Digite o nome do projeto"
                    value={moment(pagamento.dataPagamento).format("YYYY-MM-DD")}
                    min={moment().startOf("day").format(dateForValueInput)}
                    {...register("dataPagamento", { required: true })}
                    onChange={(e: any) => {
                      validarSeFinalDeSemana(e);
                    }}
                    onBlur={(e: any) => {
                      validaData(e.target.value);
                    }}
                  />
                  <FormErrorMessage>
                    {errors.dataPagamento?.message}
                  </FormErrorMessage>
                </FormControl>
              </Flex>
              <Flex flexDir={"row"}>
                <FormControl my={2} mx={2}>
                  <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                    Beneficiário
                  </FormLabel>
                  <Input
                    placeholder="Digite o nome do beneficiário"
                    value={pagamento.nomeBeneficiario}
                    {...register("nomeBeneficiario", { required: true })}
                    onChange={(e: any) => {
                      setPagamento({
                        ...pagamento,
                        nomeBeneficiario: e.target.value,
                      });
                    }}
                  />
                </FormControl>
                <FormControl my={2} mx={2}>
                  <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                    CPF/CNPJ do Beneficiário
                  </FormLabel>
                  <PatternFormat
                    customInput={Input}
                    format={
                      unMask(pagamento.cnpjBeneficiario).length > 11
                        ? "##.###.###/####-##"
                        : "###.###.###-###"
                    }
                    type="text"
                    placeholder="Digite o CPF ou CNPJ do Beneficiário"
                    value={pagamento.cnpjBeneficiario}
                    // {...register("cnpjDestinatario", { required: true })}
                    onChange={(e: any) => {
                      setPagamento({
                        ...pagamento,
                        cnpjBeneficiario: e.target.value,
                      });
                    }}
                    onBlur={(e: any) => {
                      validateCNPJ(e.target.value);
                    }}
                  />
                  <Text color={colors.REDMONEDD}>
                    {errors.cnpjBeneficiario?.message}
                  </Text>
                </FormControl>
                <FormControl my={2} mx={2}>
                  <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                    Observação
                  </FormLabel>
                  <Input
                    placeholder="observações..."
                    value={pagamento.observacao}
                    {...register("observacao", { required: true })}
                    onChange={(e: any) => {
                      setPagamento({
                        ...pagamento,
                        observacao: e.target.value,
                      });
                    }}
                  />
                </FormControl>
              </Flex>
              <Button
                isDisabled={listaPagamento.length < 5 ? false : true}
                // type="submit"
                onClick={() => onSubmit()}
                mt={5}
                leftIcon={<FiPlus />}
                bgColor={colors.BLUEMONEDDBUTTONS}
                style={{ color: "white" }}
                _hover={{ bg: "#4B4B57" }}
              >
                Cadastrar
              </Button>
            </form>
          </Flex>
        </Box>
        <Box
          width={"100%"}
          bgColor={colors.WHITE}
          height={"fit-content"}
          shadow={"md"}
          mt={"0.3%"}
          mx="auto"
          py={3}
          px={10}
        >
          <TableContainer>
            <Text fontSize={"18px"} fontWeight={"600"} mb={2}>
              Lista de Solicitação de Pagamentos
            </Text>
            <Table variant={"striped"}>
              <Thead h="60px">
                <Tr>
                  {/* <Th bgColor={VARIANT} color={WHITE}>
                    Cliente
                  </Th> */}
                  <Th
                    w={"300px"}
                    borderRadius={"8px 0 0 8px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Beneficiário
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Vencimento
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Valor
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Juros
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Descontos
                  </Th>
                  <Th
                    w={"300px"}
                    borderRadius={"0 8px 8px 0"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Código de Barras
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {listaPagamento.length > 0 &&
                  listaPagamento.map((item, index) => {
                    return (
                      <Tr key={index}>
                        {/* <Td>{item.nomeCliente}</Td> */}
                        <Td borderRadius={"8px 0px 0px 8px"}>
                          {item.nomeBeneficiario ? item.nomeBeneficiario : ""}
                        </Td>
                        <Td>{moment(item.vencimento).format(dateForList)}</Td>
                        <Td>
                          {item.valorNominal.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </Td>
                        <Td>
                          {item.juros.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </Td>
                        <Td>
                          {item.descontos.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </Td>
                        <Td borderRadius={"0px 8px 8px 0px"}>
                          {item.codigoBarras}
                        </Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </TableContainer>
          <Button
            isDisabled={listaPagamento.length ? false : true}
            // type="submit"
            onClick={() => setOpenCodeModal(true)}
            mt={5}
            leftIcon={<FiPlus />}
            bgColor={colors.BLUEMONEDDBUTTONS}
            style={{ color: "white" }}
            _hover={{ bg: "#4B4B57" }}
            isLoading={loading}
          >
            Enviar Para Pagamento
          </Button>
        </Box>
      </Flex>
      <ModalSendACodeToPay
        isOpen={openCodeModal}
        setIsOpen={setOpenCodeModal}
        functionPai={postPagamentos}
        setCode={setCode}
        type={"pagamento"}
        email={user.email}
      />
    </Flex>
  );
}

export default AddPayment;
